import { combineReducers } from "redux";

function GeocommReducer() {
  const GeocommsInitialState = {
    error: null,
    loading: false,
    loadingDeviceData: false,
    loadingPing: [],
    devices: null,
    deviceData: null,
  };

  const devices = (state = GeocommsInitialState, action) => {
    const { type, payload } = action;

    switch (type) {
      case "GET_DEVICES_INIT":
        return {
          ...state,
          loading: true,
          error: null,
          devices: null,
        };
      case "GET_DEVICES_SUCCESS":
        return {
          ...state,
          loading: false,
          error: null,
          devices: payload,
        };
      case "GET_DEVICES_ERROR":
        return {
          ...state,
          loading: false,
          error: payload,
          devices: null,
        };
      case "GET_DEVICE_DATA_INIT":
        return {
          ...state,
          loadingDeviceData: true,
          error: null,
          deviceData: null,
        };
      case "GET_DEVICE_DATA_SUCCESS":
        return {
          ...state,
          loadingDeviceData: false,
          error: null,
          deviceData: payload,
        };
      case "GET_DEVICE_DATA_ERROR":
        return {
          ...state,
          loadingDeviceData: false,
          error: payload,
          deviceData: null,
        };
      case "SAVE_GEOCOMM_DEVICE_INIT":
        return {
          ...state,
          loading: true,
          error: null,
        };
      case "SAVE_GEOCOMM_DEVICE_SUCCESS":
        return {
          ...state,
          loading: false,
          error: null,
          devices: payload,
        };
      case "SAVE_GEOCOMM_DEVICE_ERROR":
        return {
          ...state,
          loading: false,
          error: payload,
        };
      case "DELETE_GEOCOMM_DEVICE_INIT":
        return {
          ...state,
          loading: true,
          error: null,
        };
      case "DELETE_GEOCOMM_DEVICE_SUCCESS":
        return {
          ...state,
          loading: false,
          error: null,
          devices: state.devices.filter(
            (device) => device.geocommDeviceId != payload,
          ),
        };
      case "DELETE_GEOCOMM_DEVICE_ERROR":
        return {
          ...state,
          loading: false,
          error: payload,
        };
      case "PING_DEVICE_INIT":
        return {
          ...state,
          loadingPing: state.loadingPing.concat([payload.geocommDeviceId]),
          loadingDeviceData: true,
          error: null,
          deviceData: null,
        };
      case "PING_DEVICE_SUCCESS":
        return {
          ...state,
          loadingPing: state.loadingPing.filter(
            (id) => id != payload.geocommDeviceId,
          ),
          loadingDeviceData: false,
          error: null,
          devices: state.devices.map((device) => {
            if (device.geocommDeviceId == payload.geocommDeviceId) {
              device.totalPingCount = device.totalPingCount + 1;
              const recentDeviceData = payload.data[0];
              if (
                recentDeviceData &&
                recentDeviceData.location != "" &&
                recentDeviceData.clientInit
              ) {
                device.successPingCount = device.successPingCount + 1;
              }
            }
            return device;
          }),
          deviceData: payload.data,
        };
      case "PING_DEVICE_ERROR":
        return {
          ...state,
          loadingPing: state.loadingPing.filter(
            (id) => id != payload.geocommDeviceId,
          ),
          loadingDeviceData: false,
          error: payload.data,
          deviceData: null,
        };
      default:
        return state;
    }
  };

  return combineReducers({
    devices,
  });
}

export default GeocommReducer();
